import DataRoomNdaOverrideStatusModal from './DataRoomNdaOverrideStatusModal.component';

export default DataRoomNdaOverrideStatusModal;
